module.exports = __webpack_public_path__ + "img/Ellipsis.05cc011a.svg";